export const APP_NAME = 'Mawi Coder';
export const APP_VERSION = '0.1.0';

const getEnv = (key: string, defaultValue: string = ''): string => {
  // @ts-ignore - Vite env
  return import.meta.env[key] || defaultValue;
};

export const API_BASE_URL = getEnv('VITE_API_BASE_URL');
export const SOCKET_URL = getEnv('VITE_SOCKET_URL');
export const USE_MOCK_API = getEnv('VITE_USE_MOCK_API') === 'true';
export const MOCK_DELAY = parseInt(getEnv('VITE_MOCK_DELAY', '500'));

export const DEFAULT_MODEL = '';

export const SUPPORTED_FILE_TYPES = [
  'application/epub+zip',
  'application/pdf',
  'text/plain',
  'text/csv',
  'text/xml',
  'text/html',
  'text/x-python',
  'text/css',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/markdown',
  'audio/mpeg',
  'audio/wav',
  'audio/ogg',
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
];

export const SUPPORTED_FILE_EXTENSIONS = [
  'md', 'rst', 'go', 'py', 'java', 'sh', 'bat', 'ps1', 'cmd', 'js', 'ts',
  'css', 'cpp', 'hpp', 'h', 'c', 'cs', 'htm', 'html', 'sql', 'log', 'ini',
  'pl', 'pm', 'r', 'dart', 'dockerfile', 'env', 'php', 'hs', 'lua', 'nginxconf',
  'conf', 'm', 'mm', 'plsql', 'perl', 'rb', 'rs', 'db2', 'scala', 'bash',
  'swift', 'vue', 'svelte', 'doc', 'docx', 'pdf', 'csv', 'txt', 'xls', 'xlsx',
  'pptx', 'ppt', 'msg', 'json', 'yaml', 'yml', 'xml', 'zip', 'epub',
];

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const MAX_FILES_PER_CHAT = 10;

export const KEYBOARD_SHORTCUTS = {
  NEW_CHAT: { keys: ['ctrl', 'shift', 'n'], description: 'New chat' },
  FOCUS_INPUT: { keys: ['ctrl', 'shift', 'i'], description: 'Focus input' },
  TOGGLE_SIDEBAR: { keys: ['ctrl', 'shift', 's'], description: 'Toggle sidebar' },
  OPEN_SETTINGS: { keys: ['ctrl', ','], description: 'Open settings' },
  SEND_MESSAGE: { keys: ['ctrl', 'enter'], description: 'Send message' },
};

export const DEFAULT_PROMPT_SUGGESTIONS = [
  { title: ['Explain', 'a complex topic'], content: 'Explain quantum computing in simple terms' },
  { title: ['Write', 'code'], content: 'Write a Python function to sort a list' },
  { title: ['Summarize', 'text'], content: 'Summarize the key points of this article' },
  { title: ['Brainstorm', 'ideas'], content: 'Brainstorm ideas for a birthday party' },
];